import React from 'react';

const DogwoodLogo = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Four dogwood petals with characteristic notched tips */}
      {/* Top petal */}
      <path
        d="M50 8 C55 20, 58 30, 55 42 C52 44, 48 44, 45 42 C42 30, 45 20, 50 8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Notch at top */}
      <path
        d="M48 10 L50 6 L52 10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Right petal */}
      <path
        d="M92 50 C80 55, 70 58, 58 55 C56 52, 56 48, 58 45 C70 42, 80 45, 92 50"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Notch at right */}
      <path
        d="M90 48 L94 50 L90 52"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Bottom petal */}
      <path
        d="M50 92 C45 80, 42 70, 45 58 C48 56, 52 56, 55 58 C58 70, 55 80, 50 92"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Notch at bottom */}
      <path
        d="M52 90 L50 94 L48 90"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Left petal */}
      <path
        d="M8 50 C20 45, 30 42, 42 45 C44 48, 44 52, 42 55 C30 58, 20 55, 8 50"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Notch at left */}
      <path
        d="M10 52 L6 50 L10 48"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Center cluster - small circles */}
      <circle cx="50" cy="50" r="6" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="50" cy="47" r="1.5" fill="currentColor" />
      <circle cx="53" cy="50" r="1.5" fill="currentColor" />
      <circle cx="50" cy="53" r="1.5" fill="currentColor" />
      <circle cx="47" cy="50" r="1.5" fill="currentColor" />
    </svg>
  );
};

export default DogwoodLogo;
